import { field, text } from "@nozbe/watermelondb/decorators";
import { BaseModel } from "./Base";

export default class Location extends BaseModel {
  static table = "locations";
  @text("name") name: string;
  @text("retailer_location_key") retailerLocationKey?: string;
  @field("enabled") enabled: boolean;
}
